var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "figure",
    {
      class: [
        "z-blockquote",
        ((_obj = {}),
        (_obj["z-blockquote--size-" + this.size] = this.size),
        _obj),
      ],
    },
    [
      _vm.author.photo
        ? _c("div", {
            staticClass: "z-blockquote__author-photo",
            style: "background-image: url(" + _vm.author.photo + ")",
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "z-blockquote__wrapper" }, [
        !!this.$slots["text"] || _vm.text
          ? _c("div", { staticClass: "z-blockquote__body" }, [
              _vm.text
                ? _c(
                    "blockquote",
                    { domProps: { innerHTML: _vm._s(_vm.text) } },
                    [_vm._t("text")],
                    2
                  )
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.date || _vm.author.name
          ? _c(
              "div",
              { staticClass: "z-blockquote__footer" },
              [
                _vm.author.photo
                  ? _c("div", {
                      staticClass:
                        "z-blockquote__author-photo z-blockquote__author-photo--mobile",
                      style: "background-image: url(" + _vm.author.photo + ")",
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "z-blockquote__footer-wrapper" }, [
                  _c("div", {
                    staticClass: "z-blockquote__name",
                    domProps: { innerHTML: _vm._s(_vm.author.name) },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "z-blockquote__footer-container" },
                    [
                      _c(
                        "div",
                        { staticClass: "z-blockquote__info-container" },
                        [
                          _c("span", {
                            staticClass: "z-blockquote__info",
                            domProps: { innerHTML: _vm._s(_vm.author.info) },
                          }),
                          _vm._v(" "),
                          _vm.date && _vm.author.info
                            ? _c("span", {
                                staticClass: "z-blockquote__footer-divider",
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.date
                            ? _c("span", {
                                staticClass: "z-blockquote__date",
                                domProps: { innerHTML: _vm._s(_vm.date) },
                              })
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.link
                        ? _c(
                            "z-link",
                            {
                              staticClass: "z-blockquote__link-text",
                              attrs: {
                                href: _vm.linkToDetail,
                                "custom-icon": "arrow",
                                "icon-position": "right",
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.textLink) +
                                  "\n                    "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _vm._t("footer"),
              ],
              2
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }